export enum GameTypes {
    Crash = "Crash",
    RedBlack = "RedBlack",
    Slots = "Slots"
}
